export const TranslationSteps = { CHOOSE_LANGUAGE: "CHOOSE_LANGUAGE", EDIT_TRANSLATION: "EDIT_TRANSLATION" };
export const devices = ["Desktop", "Tablet", "Phone", "MobileApp"];
